<!-- Унифицированная карточка раздела настроек со ссылками на страницы. -->
<template>
  <div class="settings-section card">
    <div class="section-header">
      <div class="section-icon" :class="`section-icon--${iconVariant}`">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          v-html="icon"
        />
      </div>
      <h3 class="section-title">{{ title }}</h3>
    </div>

    <div class="section-content">
      <base-button
        v-for="link in links"
        :key="link.label"
        class="settings-link"
        role="button"
        tabindex="0"
        @click="$router.push(link.route)"
      >
        <span class="link-text">{{ link.label }}</span>
      </base-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "SettingSection",

  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    iconVariant: {
      type: String,
      required: true,
    },
    links: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
.settings-section {
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 10px;
  background: #fff;
  border: 1px solid #e8e8e8;
  break-inside: avoid;
  margin-bottom: var(--base-out-indent);
  page-break-inside: avoid;
}

.settings-section:hover {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}

.section-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: var(--base-in-indent);
}

.section-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 10px;
  flex-shrink: 0;
  transition: transform 0.3s ease;
}

.settings-section:hover .section-icon {
  transform: scale(1.06);
}

.section-icon--roles {
  background: linear-gradient(135deg, #f97316 0%, #ef4444 100%);
  color: #fff;
}

.section-icon--documents {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  color: #fff;
}

.section-icon--expenses {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  color: #fff;
}

.section-icon--registries {
  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
  color: #fff;
}

.section-icon--reference {
  background: linear-gradient(135deg, #fa8231 0%, #f7b731 100%);
  color: #fff;
}

.section-icon--telemetry {
  background: linear-gradient(135deg, #0ea5e9 0%, #2563eb 100%);
  color: #fff;
}

.section-icon--tools {
  background: linear-gradient(135deg, #22c55e 0%, #0f766e 100%);
  color: #fff;
}

.section-icon--transport {
  background: linear-gradient(135deg, #64748b 0%, #0f766e 100%);
  color: #fff;
}

.section-icon--access {
  background: linear-gradient(135deg, #6366f1 0%, #7c3aed 100%);
  color: #fff;
}

.section-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.settings-link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease;
}

.link-text {
  flex: 1;
}
</style>
